import { useState } from "react";
import { Avatar, Box, Button, CircularProgress, ListItemAvatar, MenuItem, Paper, Select, TextField, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { MyListApi } from "../utils/restApi";
import { addNotification } from "../slices/notificationSlice";
import { ProfileImageUploadDialog } from "./ProfileImageUploadDialog";
import { Menu } from "@mui/icons-material";

const PRIVACY_LEVELS = [
    'PUBLIC', 'PRIVATE', 'FRIENDS'
];

const TagSelect = props => {

    const [tag, setTag] = useState();

    return (
        <Select
            value={tag}
            fullWidth
        >
            <MenuItem value="one" >
                <ListItemAvatar>
                    <Avatar />
                </ListItemAvatar>
                <Typography>Books</Typography>
            </MenuItem>
            <MenuItem value="two">Two</MenuItem>
            <MenuItem value="three">Three</MenuItem>
        </Select>
    );
}

export const Settings = () => {

    const dispatch = useDispatch();
    const user = useSelector(state => state.login.user);
    const [privacyLevel, setPrivacyLevel] = useState(user?.privacyLevel || 'PRIVATE');
    const [saving, setSaving] = useState(false);
    const saveDisabled = user?.privacyLevel === privacyLevel || saving;
    const [profileImage, setProfileImage] = useState(user?.profile?.avatar);

    const handleSave = () => {
        setSaving(true);
        MyListApi.updateUser({
                privacyLevel: privacyLevel,
            })
            .then(_ => {
                setSaving(false);
            })
            .catch(error => {
                dispatch(addNotification({
                    message: error.message,
                    type: 'error',
                }));
            });
    }

    return (
        <Paper sx={{ p: '20px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {/* <Box>
                <TagSelect />
            </Box> */}
            <ProfileImageUploadDialog label="Profile Image" value={profileImage} />
            <Box>
                <TextField
                    variant='filled'
                    select
                    value={privacyLevel}
                    label='Privacy Level'
                    onChange={e => setPrivacyLevel(e.target.value)}
                >
                    {PRIVACY_LEVELS.map(pl => <MenuItem key={pl} value={pl}>{pl}</MenuItem>)}
                </TextField>
            </Box>
            <Button onClick={handleSave} variant='contained' disabled={saveDisabled}>{saving ? <CircularProgress /> : 'Save'}</Button>

        </Paper>
    );
}